import { enrichTransactionRows } from './enrichTransactions';
import { computeReconciliationSummary } from './computeSummary';
import { computeReportAnalytics } from './computeReportAnalytics';
import { buildEnterpriseWorkbook } from './excel/v2/buildWorkbook';
import { isMobileExportDevice } from './excel/v2/mobileCompat';
import { downloadBytes } from './downloadFile';

export function buildEnterpriseXlsxFilename({ from, to, prefix = 'DE-Reconciliation' } = {}) {
  const stamp = new Date().toISOString().slice(0, 10);
  const range = from && to ? `_${from}_to_${to}` : from ? `_from_${from}` : to ? `_to_${to}` : '';
  return `${prefix}${range}_${stamp}.xlsx`;
}

export async function downloadXlsxBuffer(buffer, filename) {
  await downloadBytes(
    buffer,
    filename,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
}



export async function buildEnterpriseXlsx(transactions = [], ctx = {}, meta = {}, { preEnriched = false, debugExport = false, mobileCompat } = {}) {

  const rows = preEnriched ? transactions : enrichTransactionRows(transactions, ctx);

  const summary = computeReconciliationSummary(

    preEnriched ? transactions.map((r) => ({ ...r, amount: r.amount, type: r.type })) : transactions,

    ctx.inferChannel,

    ctx.inferStatus,

  );

  const analytics = computeReportAnalytics(rows);

  const result = await buildEnterpriseWorkbook({

    rows,

    summary,

    analytics,

    meta: {

      ...meta,

      generatedBy: meta.generatedBy || 'Development Express Admin Portal',

      debugExport: meta.debugExport || debugExport,

      mobileCompat: mobileCompat ?? isMobileExportDevice(),

    },

  });

  return {

    buffer: result.buffer,

    rows,

    summary,

    analytics,

    validation: result.validation,

    reportId: result.reportId,

    sheetNames: result.sheetNames,

    tableNames: result.tableNames,

  };

}



export async function exportFilteredReconciliationXlsx(transactions, ctx, meta = {}, options = {}) {

  const { buffer, rows, validation, reportId, sheetNames } = await buildEnterpriseXlsx(transactions, ctx, meta, options);

  const filename = buildEnterpriseXlsxFilename({ from: meta.from, to: meta.to });

  await downloadXlsxBuffer(buffer, filename);

  if (meta.debugExport || options.debugExport) {

    // eslint-disable-next-line no-console

    console.log('[ExcelExport v2]', { filename, reportId, validation, sheetNames });

  }

  return { filename, rowCount: rows.length, sheetCount: 7, validation, reportId };

}


